import React, { useEffect } from "react";

export const Navigation = (props) => {
  useEffect(() => {
    // Close navbar on link click (for mobile)
    const navLinks = document.querySelectorAll(".navbar-collapse ul li a");
    const navCollapse = document.querySelector(".navbar-collapse");

    navLinks.forEach((link) => {
      link.addEventListener("click", () => {
        if (navCollapse.classList.contains("in")) {
          navCollapse.classList.remove("in"); // collapse
        }
      });
    });
  }, []);

  return (
    <nav id="menu" className="navbar navbar-default navbar-fixed-top">
      <div className="container">
        <div className="navbar-header">
          <button
            type="button"
            className="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#bs-example-navbar-collapse-1"
          >
            <span className="sr-only">Toggle navigation</span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
          </button>
          <a
            className="navbar-brand page-scroll"
            href="#page-top"
            style={{ display: "flex", alignItems: "center", height: "60px" }}
          >
            <img
              src="img/logo.png"
              alt="Logo"
              style={{
                maxHeight: "48px",
                width: "auto",
                display: "block",
                objectFit: "contain",
              }}
            />
          </a>
        </div>

        <div
          className="collapse navbar-collapse"
          id="bs-example-navbar-collapse-1"
        >
          <ul className="nav navbar-nav navbar-right">
            <li>
              <a href="#about" className="page-scroll">About</a>
            </li>
            <li>
              <a href="#team" className="page-scroll">Brands</a>
            </li>
            <li>
              <a href="#features" className="page-scroll">MORE PRODUCTS</a>
            </li>
            <li>
              <a href="#services" className="page-scroll">FARMER ENGAGEMENT</a>
            </li>
            {/*<li>
              <a href="#track-record" className="page-scroll">TRACK RECORD</a>
            </li>*/}
            <li>
              <a href="#contact" className="page-scroll">Contact</a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};
